
import { IReportsRepository } from "../../repositories/reports_repository";
import { IGetReportFvsDinamicoUseCase } from "../../../presentation/useCases/read/get_report_fvs_dinamico_use_case";
import { ReportFvsDinamicoFilters } from "../../models/report_fvs_dinamico_filters";


export class GetReportFvsDinamicoUseCase implements IGetReportFvsDinamicoUseCase {
  constructor(private readonly repository: IReportsRepository) {}

  async getReportFvsDinamico(idObra: number, idUsuario: number, filters?: ReportFvsDinamicoFilters): Promise<string> {
    if (!Number.isInteger(idObra) || idObra <= 0) {
      throw new Error("Selecione uma obra válida.");
    }

    return await this.repository.getReportFvsDinamico(idObra, idUsuario, filters);
  }
}
